import { CheckboxV2, FAIconName, FireflyButton } from '@equip.health/ui';

import Authorization from '~/components/common/billingPeriods/BillingPeriodAuthorization';
import {
  UseBillingPeriodState,
  initialAuthorizationState,
} from '~/components/common/billingPeriods/useBillingPeriod';
import { BILLING_PERIODS_TOP_LEVEL_ID } from '~/lib/constants';

interface AuthorizationsProps {
  authorizations: BillingPeriodAuthorization[];
  showRequiredFieldErrors: boolean;
  isAuthorizationRequired: boolean;
  isReadOnly?: boolean;
  billingPeriodState?: UseBillingPeriodState;
}

const Authorizations = ({
  authorizations,
  showRequiredFieldErrors,
  isAuthorizationRequired,
  isReadOnly,
  billingPeriodState,
}: AuthorizationsProps) => {
  const { updateBillingPeriodState } = billingPeriodState;

  return (
    <>
      <CheckboxV2
        id={`${BILLING_PERIODS_TOP_LEVEL_ID}__auth-required`}
        isChecked={isAuthorizationRequired}
        isDisabled={isReadOnly}
        label="Authorization is required"
        onChange={(value: boolean) =>
          updateBillingPeriodState({
            isAuthRequired: value,
          })
        }
      />
      {authorizations?.map((authorization, index) => {
        return (
          <Authorization
            allAuthorizations={authorizations}
            billingPeriodState={billingPeriodState}
            currentAuthorization={authorization}
            index={index}
            isReadOnly={isReadOnly}
            key={index}
            showRequiredFieldErrors={showRequiredFieldErrors}
          />
        );
      })}
      {!isReadOnly && (
        <FireflyButton
          id={`${BILLING_PERIODS_TOP_LEVEL_ID}__auth-add`}
          leftIcon={FAIconName.plusSolid}
          onClick={() => {
            const newAuthorizations = authorizations?.length
              ? [...authorizations, initialAuthorizationState]
              : [initialAuthorizationState];
            updateBillingPeriodState({
              authorizationDetails: newAuthorizations,
            });
          }}
          size="small"
          variant="secondary"
        >
          Add authorization
        </FireflyButton>
      )}
    </>
  );
};

export default Authorizations;
